import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function BarChartIcon(props) {
	return (
		<IconBase type="bar-chart" {...props}>
			<path d="M5 9.2H8V19H5V9.2ZM10.6 5H13.4V19H10.6V5ZM16.2 13H19V19H16.2V13Z" />
		</IconBase>
	);
}
BarChartIcon.propTypes = iconPropTypes;
